
   import { defineComponent } from "vue";

   export interface BreadCrumb {
      title: string,
      url: string | null
   }

   export default defineComponent({
      props: [ 'crumbs', 'title' ]
   });

